<template>
  <div class="panel">
    <div v-if="isError" class="reload-chat">
      <div class="text-center">
        <p>Network error!!</p>
        <button class="btn btn-primary btn-sm" @click="prepareData">
          Reload
        </button>
      </div>
    </div>
    <div v-else class="h-100">
      <div class="loading-prepare" v-if="isPrepare">
        <div class="spinner-grow text-secondary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div v-else class="card-box">
        <div class="card-box-header msg_head">
          <div class="d-flex bd-highlight">
            <div
              v-if="!isShowBoth"
              class="img_back mr-3"
              @click="$emit('show-list-chat')"
            >
              <font-awesome-icon
                :icon="['fas', 'chevron-left']"
                class="img_back_icon"
              />
            </div>
            <div v-if="!isShowBoth" class="img_cont">
              <div
                v-if="otherInfo.photoUrl && otherInfo.photoUrl.trim()"
                class="rounded-circle user_img"
              >
                <div
                  class="rounded-circle user_img_display"
                  v-bind:style="{
                    backgroundImage: 'url(' + otherInfo.photoUrl + ')',
                  }"
                ></div>
              </div>
              <font-awesome-icon
                v-else
                :icon="['fas', 'user']"
                class="rounded-circle user_img"
              />
              <!-- <span class="online_icon"></span> -->
            </div>
            <div class="user_info">
              <span>{{
                !otherInfo.name || otherInfo.name.trim().length == 0
                  ? "user" + otherInfo.id.split("getfin")[1]
                  : otherInfo.name
              }}</span>
            </div>
          </div>
        </div>
        <div v-if="isNoConversation" class="panel-wellcome-chat">
          <div class="text-center">
            <div class="wrap-other-chat-img mb-2 mx-auto">
              <div
                class="other-chat-img rounded-circle"
                v-bind:style="{
                  backgroundImage: 'url(' + otherInfo.photoUrl + ')',
                }"
              ></div>
            </div>
            <p class="mb-0">{{ $t("startChatWith") }} {{ otherInfo.name }}</p>
          </div>
        </div>
        <div v-else class="wrpa-msg_card_body">
          <div
            v-if="isLoadingConversation && conversation.data !== null"
            class="loading-message w-100 text-center"
          >
            <div class="spinner-grow text-secondary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div
            v-show="conversation.data && conversation.data !== null"
            class="msg_card_body"
            id="chatMsgCardBody"
          >
            <ChatBoxMessageList
              :messageList="conversation.data.slice().reverse()"
              :meProfile="meProfile"
              :otherInfo="otherInfo"
            />
            <ChatBoxMessageList
              :messageList="dummyMessageList"
              :meProfile="meProfile"
              :otherInfo="otherInfo"
            />
          </div>
        </div>
        <div class="wrap-card-box-footer">
          <div class="input-group py-2 px-1 d-flex">
            <div class="input-group-append">
              <span
                class="input-group-text attach_btn"
                @click="handleBrowseImg"
              >
                <font-awesome-icon :icon="['fas', 'image']" class="" />
              </span>
              <input
                type="file"
                name="chatBoxInputFile"
                id="chatBoxInputFile"
                style="display:none;"
                accept="image/png, image/jpeg"
                @change="preparePushFile"
                multiple
              />
            </div>
            <textarea
              id="chatInboxTextArea"
              name="chatInboxTextArea"
              class="form-control type_msg"
              :placeholder="$t('sendChat')"
              v-model="textInput"
              @keypress="handlePushMessage"
              @keyup="resizeTextArea"
              @keydown="resizeTextArea"
              @focus="readMessage"
              rows="1"
            ></textarea>
            <div class="input-group-append" @click="preparePushMessage">
              <span class="input-group-text send_btn">
                <font-awesome-icon :icon="['fas', 'location-arrow']" class="" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChatBoxMessageList from "@/components/chat/ChatBoxMessageList.vue";
export default {
  name: "ChatBox",
  components: {
    ChatBoxMessageList,
  },
  props: {
    meProfile: {
      required: true,
      type: Object,
    },
    otherProfile: {
      required: true,
      type: Object,
    },
    isFromList: {
      required: false,
      type: Boolean,
    },
    isShowBoth: {
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {
      isNoConversation: false,
      isError: false,
      isPrepare: true,
      isFirstLoad: true,
      isLoadingConversation: false,
      isWaitingLoadingCon: false,
      coundDownWaitingLoadingCon: 5,
      textInput: "",
      formatIdConversation: "",
      otherInfo: {
        targetApp: null,
        name: "",
        email: [],
        photoUrl: " ",
        role: "",
        phone: null,
        welcomeMessage: "",
      },
      filterConversation: {
        limit: 15,
      },
      conversation: {
        data: [],
      },
      isBusyCon: false,
      heightDivChatMsgCardBody: 0,
      dummyMessageList: [],
    };
  },
  methods: {
    prepareData: async function() {
      this.isFirstLoad = true;
      this.isPrepare = true;
      this.isError = false;
      this.$emit("set-show-title", false);
      this.formatIdConversation = `${this.meProfile.chatId}___${this.otherProfile.chatId}`;
      if (this.isFromList) {
        this.getOther();
      } else {
        this.updateOther();
      }
      this.initConversation();
      this.getConversation(true, false);
      this.readMessage();
      // this.$store.commit("chat/setStateInbox", false);
    },
    updateOther() {
      let tempOtherName = this.otherProfile.chatId.split("getfin");
      tempOtherName = "user" + tempOtherName[1];
      let body = {
        name:
          this.otherProfile.firstName || this.otherProfile.lastName
            ? `${this.otherProfile.firstName} ${this.otherProfile.lastName}`
            : tempOtherName,
        email: [],
        photoUrl: this.otherProfile.imageUrl || " ",
        role: this.$chatRole,
      };

      fetch(`${this.$chatBaseUrl}/talkjs/user/${this.otherProfile.chatId}`, {
        method: "POST",
        headers: new Headers(this.$headersChat),
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.result) {
            this.getOther();
          } else {
            this.handleLoadError();
          }
        })
        .catch((error) => {
          this.handleLoadError();
          console.log("error", error);
        });
    },
    getOther() {
      fetch(`${this.$chatBaseUrl}/talkjs/user/${this.otherProfile.chatId}`, {
        method: "GET",
        headers: new Headers(this.$headersChat),
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.result) {
            this.otherInfo = result.detail;
          } else {
            this.handleLoadError();
          }
        })
        .catch((error) => {
          this.handleLoadError();
          console.log("error", error);
        });
    },
    getConversation(isForceScrollToBottom, isInfiniteScroll) {
      if (this.isWaitingLoadingCon && this.coundDownWaitingLoadingCon > 0) {
        this.coundDownWaitingLoadingCon--;
        return;
      }
      this.isWaitingLoadingCon = true;
      this.coundDownWaitingLoadingCon = 5;
      let startingAfter = "";
      if (isInfiniteScroll && this.conversation.data.length) {
        startingAfter = this.conversation.data[
          this.conversation.data.length - 1
        ].id;
      }
      let body = {
        limit: this.filterConversation.limit,
        startingAfter: startingAfter,
      };
      fetch(`${this.$chatBaseUrl}/talkjs/${this.formatIdConversation}`, {
        method: "POST",
        headers: new Headers(this.$headersChat),
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((result) => {
          this.isWaitingLoadingCon = false;
          if (result.result) {
            this.heightDivChatMsgCardBody = 0;
            if (
              result.detail.message == null ||
              (result.detail.message.length < 1 && this.isFirstLoad)
            ) {
              this.isFirstLoad = false;
              this.isPrepare = false;
              this.isNoConversation = true;
              return;
            }
            this.isNoConversation = false;
            if (isInfiniteScroll) {
              this.isLoadingConversation = false;
              let tempObjDiv = document.getElementById("chatMsgCardBody");
              this.heightDivChatMsgCardBody = tempObjDiv.scrollHeight;
            }
            result.detail.message.forEach((mess) => {
              if (this.dummyMessageList.length) {
                let indx = this.dummyMessageList.findIndex(
                  (temp) =>
                    mess.checkingId && mess.checkingId === temp.checkingId
                );
                if (indx >= 0) {
                  this.dummyMessageList.splice(indx, 1);
                }
              }
            });
            if (
              this.conversation.data.length &&
              result.detail.message &&
              !isInfiniteScroll
            ) {
              let tempResultData = result.detail.message;
              let tempConData = this.conversation.data;

              let idxCon = tempConData.findIndex(
                (itm) => itm.id === tempResultData[tempResultData.length - 1].id
              );
              tempConData.splice(0, idxCon + 1);
              this.conversation.data = tempResultData.concat(tempConData);
            } else {
              this.conversation.data = this.conversation.data.concat(
                result.detail.message
              );
            }
            if (isForceScrollToBottom && !this.isError) {
              setTimeout(() => {
                let objDiv = document.getElementById("chatMsgCardBody");
                objDiv.scrollTop = objDiv.scrollHeight;
              }, 100);
            }
            if (!this.isFirstLoad) {
              let objDiv2 = document.getElementById("chatMsgCardBody");
              setTimeout(() => {
                if (isInfiniteScroll) {
                  objDiv2.scrollTop =
                    objDiv2.scrollHeight - this.heightDivChatMsgCardBody;
                } else {
                  if (
                    objDiv2.scrollHeight -
                      objDiv2.scrollTop -
                      objDiv2.clientHeight <
                    150
                  ) {
                    objDiv2.scrollTop = objDiv2.scrollHeight;
                  }
                }
              }, 100);
            }
            if (this.isFirstLoad) {
              setTimeout(() => {
                document.getElementById("chatMsgCardBody").addEventListener(
                  "scroll",
                  async () => {
                    if (
                      document.getElementById("chatMsgCardBody").scrollTop ==
                        0 &&
                      !this.isBusyCon
                    ) {
                      this.isBusyCon = true;
                      this.isLoadingConversation = true;
                      this.heightDivChatMsgCardBody = 0;
                      this.getConversation(false, true);
                    }
                  },
                  false
                );
              }, 500);
              this.isPrepare = false;
              this.isFirstLoad = false;
            }
            this.$emit("handle-no-list-chat", false);
          } else {
            this.handleLoadError();
          }
          if (isInfiniteScroll) {
            if (result.detail.message.length > 0) {
              this.isBusyCon = false;
            } else {
              this.isBusyCon = true;
            }
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.handleLoadError();
        });
    },
    handlePushMessage(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.preparePushMessage();
      }
    },
    preparePushMessage() {
      if (this.textInput.trim().length > 0) {
        let dataSend = {
          text: this.textInput,
          attachments: [],
        };
        this.textInput = "";
        this.sendMessage(dataSend, 1); // 1 = type text
      }
    },
    preparePushFile(e) {
      if (e.target.files.length) {
        let dataSend = {
          text: this.textInput,
          attachments: [],
        };
        e.target.files.forEach((file, i) => {
          if (file.size < 4194304) {
            //Max 4MB
            let readerFile = new FileReader();
            readerFile.readAsDataURL(file);
            readerFile.onload = () => {
              dataSend.attachments.push(readerFile.result);
              if (i + 1 === e.target.files.length)
                this.sendMessage(dataSend, 6); // 6 = type img
            };
          }
        });
      }
    },
    sendMessage: async function(dataSend, type) {
      let dt = new Date();
      let checkingId =
        Math.round(+new Date() / 1000).toString() +
        dt.getMilliseconds().toString();
      let tempMessage = {
        senderId: this.meProfile.chatId,
        checkingId: checkingId,
        isDummy: true,
        createdTime: dt.toISOString(),
        messageResponse: {
          content: {
            content: {
              text: dataSend.text,
            },
            imageList: [
              {
                imageUrl: dataSend.attachments || [],
              },
            ],
            responseType: type,
          },
        },
      };
      this.dummyMessageList = [...this.dummyMessageList, tempMessage];
      let body = {
        ...dataSend,
        checkingId: checkingId,
        conversationId: this.formatIdConversation,
      };
      setTimeout(() => {
        let objDiv = document.getElementById("chatMsgCardBody");
        objDiv.scrollTop = objDiv.scrollHeight;
      }, 100);
      fetch(`${this.$chatBaseUrl}/talkjs/sendmessage`, {
        method: "POST",
        headers: new Headers(this.$headersChat),
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.result) {
            if (this.isNoConversation) {
              this.initConversation();
            }
            this.getConversation(true, false);
            if (this.isShowBoth) {
              if (this.conversation.data.length) {
                this.$emit("reload-detail-list", this.formatIdConversation);
              } else {
                this.$emit("reload-list");
              }
            }
          } else {
            this.handleLoadError();
          }
        })
        .catch((error) => {
          this.handleLoadError();
          console.log("error", error);
        });
    },
    handleBrowseImg() {
      document.getElementById("chatBoxInputFile").click();
      this.readMessage();
    },
    initConversation: async function() {
      let tempName = this.meProfile.chatId.split("getfin");
      tempName = "user" + tempName[1];
      let body = {
        conversationId: this.formatIdConversation,
        agentId: this.meProfile.chatId,
        agentName: this.meProfile.seller.name || tempName,
        clientId: this.otherProfile.chatId,
        clientName: this.otherInfo.name,
      };
      fetch(`${this.$chatBaseUrl}/talkjs/initConversation`, {
        method: "POST",
        headers: new Headers(this.$headersChat),
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.result) {
          } else {
            this.handleLoadError();
          }
        })
        .catch((error) => {
          this.handleLoadError();
          console.log("error", error);
        });
    },
    readMessage() {
      fetch(`${this.$chatBaseUrl}/talkjs/read/${this.formatIdConversation}`, {
        method: "GET",
        headers: new Headers(this.$headersChat),
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.result) {
            this.$emit("read-chat", this.formatIdConversation);
          } else {
            this.handleLoadError();
          }
        })
        .catch((error) => {
          this.handleLoadError();
          console.log("error", error);
        });
    },
    resizeTextArea() {
      var textArea = document.getElementById("chatInboxTextArea");
      textArea.style.height = "auto";
      textArea.style.height = textArea.scrollHeight + "px";
    },
    handleLoadError() {
      this.isError = true;
      this.isBusyCon = true;
    },
  },
  created() {
    this.prepareData();
  },
  watch: {
    "$store.state.isLoadChatConversationList": function() {
      if (this.$store.state.isLoadChatConversationList) {
        this.getConversation(false, false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.panel {
  height: 100%;
  margin: 0;
}
.card-box {
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-flow: column;
  height: 100%;
  position: relative;
}
.card-box-header {
  background-color: #fff;
  padding: 0.4rem 1rem;
}
.wrpa-msg_card_body {
  position: relative;
  height: 100%;
  padding-left: 5px;
  display: contents;
}
.msg_card_body {
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
  height: 100%;
  padding: 10px 5px 3px 5px;
}
.msg_card_body::-webkit-scrollbar {
  width: 0.35em;
}
.msg_card_body::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(177, 175, 175, 0.3);
}
.msg_card_body::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  outline: 1px solid #c1c1c1;
}
.wrap-card-box-footer {
  position: relative;
  bottom: 0;
  width: 100%;
  background: #fff;
}

.container {
  align-content: center;
}
.type_msg {
  background-color: inherit !important;
  color: #575757 !important;
  overflow: hidden;
  resize: none;
  padding-left: 15px;
  padding-right: 15px;
}
.type_msg:focus {
  box-shadow: rgba(0, 0, 0, 0.164) !important;
  outline: 0px !important;
  border: 1px solid rgba(0, 0, 0, 0.164) !important;
}
.type_msg::placeholder {
  color: #dbdbdb;
}
.attach_btn {
  border-radius: 22px !important;
  background-color: inherit !important;
  border: 0 !important;
  color: #f3591f !important;
  cursor: pointer;
}
.send_btn {
  background-color: inherit !important;
  border: 0 !important;
  color: #f3591f !important;
  cursor: pointer;
}
.active {
  background-color: rgba(0, 0, 0, 0.3);
}
.user_img {
  height: 40px;
  width: 40px;
  border: 1.5px solid #dbdbdb;
}
.user_img_display {
  width: 100%;
  padding-bottom: 100.5%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #fff;
}
.img_back {
  position: relative;
  height: 44px;
  width: auto;
}
.img_back_icon {
  height: 100%;
  width: 15px;
  color: #f3591f;
}
.img_cont {
  position: relative;
  height: 40px;
  width: 40px;
  margin-right: 15px;
}
.img_cont img {
  background-color: #fff;
}
.img_cont svg {
  padding: 5px;
}
.online_icon {
  position: absolute;
  height: 15px;
  width: 15px;
  background-color: #4cd137;
  border-radius: 50%;
  bottom: 0.2em;
  right: 0.4em;
  border: 1.5px solid white;
}
.offline {
  background-color: #c23616 !important;
}
.user_info {
  margin-top: auto;
  margin-bottom: auto;
}
.user_info span {
  font-size: 20px;
  color: rgb(43, 43, 43);
}
.video_cam {
  margin-left: 50px;
  margin-top: 5px;
}
.video_cam span {
  color: white;
  font-size: 20px;
  cursor: pointer;
  margin-right: 20px;
}
.msg_head {
  position: relative;
  border-bottom: 1px solid #e6e7eb;
}
#action_menu_btn {
  position: absolute;
  right: 10px;
  top: 10px;
  color: white;
  cursor: pointer;
  font-size: 20px;
}
.action_menu {
  z-index: 1;
  position: absolute;
  padding: 15px 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border-radius: 15px;
  top: 30px;
  right: 15px;
  display: none;
}
.action_menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.action_menu ul li {
  width: 100%;
  padding: 10px 15px;
  margin-bottom: 5px;
}
.action_menu ul li i {
  padding-right: 10px;
}
.action_menu ul li:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.2);
}

.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-radius: 22px;
}

.reload-chat,
.loading-prepare {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.loading-message {
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: inherit;
}
.loading-message .spinner-grow {
  width: 20px;
  height: 20px;
}
.panel-wellcome-chat {
  padding-top: 20%;
  align-items: center;
  justify-content: center;
  // height: 75vh;
  height: 100%;
  width: 100%;
}
.panel-wellcome-chat p {
  color: rgb(43, 43, 43);
}
.wrap-other-chat-img {
  height: 100px;
  width: 100px;
}
.other-chat-img {
  width: 100%;
  padding-bottom: 100.5%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
@media (max-width: 767.98px) {
  .card-box-header {
    padding: 0.4rem 1.25rem;
    position: sticky;
    top: 104px;
    width: 100%;
    z-index: 1;
  }
  .img_back {
    height: 30px;
  }
  .user_img {
    height: 30px;
    width: 30px;
  }
  .img_cont {
    height: 30px;
    width: 30px;
  }
  .user_info span {
    font-size: 14px;
  }
  .wrpa-msg_card_body {
    position: fixed;
    top: 104px;
    left: 0;
    // z-index: 1;
    background-color: #fff;
    width: 100%;
    // height: calc(100% - 104px - 44px - 50px);
    height: 100%;
  }
  .msg_card_body {
    position: relative;
    height: calc(100% - 104px - 44px - 50px);
    // height: 100%;
    padding: 10px 5px 3px 5px;
    // z-index: 10;
  }
  .wrap-card-box-footer {
    position: fixed;
    width: 100% !important;
    z-index: 1020;
    background-color: #fff;
    padding-bottom: 10px;
  }
}
</style>
